var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { Box } from "../../Box";
import { Icon } from "../../Icon";
import { Tooltip } from "../../Tooltip";
import { PrefixSuffixContainer } from "../internal/PrefixSuffixContainer";
import { FormInput } from "../FormInput/FormInput";
const Suffix = ({ value, name }) => (React.createElement(CopyToClipboard, { text: value, "data-trackid": `FormInputCopyButton-${name}` },
    React.createElement(Box, null,
        React.createElement(Tooltip, { content: "Copied!", autoHide: true, trigger: "click" },
            React.createElement(PrefixSuffixContainer, { cursor: "pointer", "data-testid": `FormInputCopyButton-${name}`, variant: "suffix" },
                React.createElement(Icon, { src: "Duplicate", size: "16px" }))))));
/**
 * <br /> <br />
 * ## Description
 * `FormInputCopy` is a text form field component that allows the user to copy the content of the field. <br>
 * It renders an input field with a copy button as a suffix.
 */
export const FormInputCopy = (_a) => {
    var formInputProps = __rest(_a, []);
    return (React.createElement(FormInput, Object.assign({ disabled: true, suffix: Suffix, variant: "fileInput" }, formInputProps)));
};
